import { getItem } from 'utils/localStorage'
import { CURRENT_ENV, isProduction } from 'config'

/*
  This util provides the URL Scheme that Sketch app understands,
  allowing us to interact with the Mac app

  These are the possibilities for the different environments:
  production -> sketch://sketch.cloud/s/...
  test -> sketch://test.sketch.cloud/s/...
  staging -> sketch://staging.sketch.cloud/s/...
  dev -> sketch://dev.sketch.cloud/s/...
*/
export const setSketchUrlScheme = (url: string) => {
  const sketchAppVariant = getItem('debug.sketchAppVariant')

  return isProduction()
    ? `sketch://${url}`
    : `${getVariantProtocol(sketchAppVariant)}://${CURRENT_ENV}.${url}`
}

const acceptedSketchVariants = [
  'final',
  'beta',
  'private',
  'internal',
  'experimental',
  'xcode',
  'testing',
  'feature-preview',
]

export const getVariantProtocol = (sketchVariant: string = '') =>
  acceptedSketchVariants.includes(sketchVariant)
    ? `sketch-${sketchVariant}`
    : 'sketch'
